import { createPerformableConfig, TenantId } from '~/tenants/common/registry';
import { coerceBoolean, coerceLiteralNumberRequired, FIRST_VERSION_TIMESTAMP } from '~/lib/zod';
import z from 'zod';
import * as v from 'valibot';

import { TwtOrderType } from '~/tenants/twt/model/enums';

export default createPerformableConfig(
  'nucleus',
  {
    [FIRST_VERSION_TIMESTAMP]: z.object({
      version: coerceLiteralNumberRequired(FIRST_VERSION_TIMESTAMP),
      guided: z.coerce.number().optional(),
      hotspots: z.coerce.number().optional(),
      detached: z.string().array().optional(),
      nucleus: coerceBoolean().optional(),
      videos: z.coerce.number().optional(),
      branded_url: z.string().url().optional(),
      unbranded_url: z.string().url().optional()
    }),
  },
  {
    name: 'Nucleus Walkthrough',
    thumbnail: 'tenant/twt/nucleus/self_guided.png',
    color: '#8e51b1',
    short: 'An immersive 3D walkthrough that lets buyers explore the property anytime, from any device — no scheduling required.',
    tenant: TenantId.TWIST_TOURS,
    submit: v.object({
      branded_url: v.pipe(v.string('Please provide a Branded URL.'), v.url('The branded url is not valid.')),
      unbranded_url: v.pipe(v.string('Please provide a Unbranded URL.'), v.url('The unbranded url is not valid.')),
    }),
    images: [],
  },
);
